import { Link } from 'react-router-dom'

export default function Home() {
    return (
        <div>
            <h1>Home VN Voter </h1>
            <p>
                Website made for voting during visual novel meetings!
            </p>
            <Link to="/vote">Vote for visual novel</Link>
        </div>
    );
}